import styled, { createGlobalStyle } from "styled-components";

export const HeaderCellWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 16px;
	width: 100%;
	position: relative;
	min-height: 36px;
`;

export const HeaderTitle = styled.span`
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	flex: 1 1 auto;
`;

export const IconContainer = styled.div<{ $active: boolean }>`
	display: flex;
	gap: 4px;
	align-items: center;
	opacity: ${(props) => (props.$active ? 1 : 0)};
	max-width: ${(props) => (props.$active ? "80px" : "0px")};
	margin-left: ${(props) => (props.$active ? "8px" : "0px")};
	overflow: hidden;
	pointer-events: ${(props) => (props.$active ? "auto" : "none")};
	flex-shrink: 0;
	z-index: 2;
`;

export const FilterButton = styled.button<{ $active: boolean }>`
	background: ${(props) => (props.$active ? "var(--color-pink-lighter)" : "transparent")};
	border: none;
	width: 26px;
	height: 26px;
	border-radius: 50%;
	padding: 0;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${(props) => (props.$active ? "var(--color-pink)" : "var(--antd-primary)")};
	transition: all 0.2s ease;

	&:hover {
		background: #ebeefd;
		color: var(--color-pink);
	}

	svg {
		font-size: 16px;
		stroke-width: 2px;
	}
`;

export const SortButton = styled.button<{ $active: boolean }>`
	background: ${(props) => (props.$active ? "var(--color-pink-lighter)" : "transparent")};
	border: none;
	width: 26px;
	height: 26px;
	border-radius: 50%;
	padding: 0;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${(props) => (props.$active ? "var(--color-pink)" : "var(--antd-primary)")};
	transition: all 0.2s ease;

	&:hover {
		background: #ebeefd;
		color: var(--color-pink);
	}

	svg {
		font-size: 16px;
		stroke-width: 2.5px;
	}
`;

export const SortIconSet = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
`;

export const CustomProfessionalTableGlobalStyle = createGlobalStyle`
	.custom-professional-table .ant-table-thead > tr > th:hover .header-icons {
		opacity: 1 !important;
		max-width: 80px !important;
		margin-left: 8px !important;
		pointer-events: auto !important;
	}

	.custom-professional-table .ant-table-column-sorter,
	.custom-professional-table .ant-table-filter-trigger {
		display: none !important;
	}

	.custom-professional-table .ant-table-column-sorters {
		padding-inline-end: 0 !important;
	}
`;
